module.exports = __webpack_public_path__ + "static/media/villa-branco-1.0190baa3.webp";